import Grid from "@mui/material/Grid"
import MDBox from "components/MDBox"
import MDButton from "components/MDButton"
import MDInput from "components/MDInput"
import MDNumberInput from "./MDNumberInput"
import MDSelect from "components/MDSelect"
import MDTypography from "components/MDTypography"
import { PAYMENT_TYPE_OPTIONS } from "../constants"

const PaymentLineRow = ({
  idx,
  line,
  errors,
  suppliers,
  onUpdate,
  onDuplicate,
  onRemove,
  disabled,
}) => {
  const supplierOptions = (suppliers || []).map((s) => ({
    value: s.id,
    label: s.name,
    raw: s,
  }))

  const handleSupplierChange = (option) => {
    if (!option) {
      onUpdate(idx, {
        supplierId: null,
        supplierName: "",
        supplierTaxCode: "",
        bankName: "",
        bankAccount: "",
      })
      return
    }
    const s = option.raw || {}
    onUpdate(idx, {
      supplierId: option.value,
      supplierName: option.label,
      supplierTaxCode: s.taxCode || "",
      bankName: s.bankName || "",
      bankAccount: s.bankAccount || "",
    })
  }

  return (
    <MDBox p={2} mb={2} bgColor="grey-100" borderRadius="lg">
      <MDBox display="flex" justifyContent="space-between" alignItems="center" mb={1}>
        <MDTypography variant="button" fontWeight="medium">
          Payment line #{idx + 1}
        </MDTypography>
        <MDBox display="flex" gap={1}>
          <MDButton
            size="small"
            variant="outlined"
            color="info"
            onClick={() => onDuplicate(idx)}
            disabled={disabled}
          >
            Duplicate
          </MDButton>
          <MDButton
            size="small"
            variant="outlined"
            color="error"
            onClick={() => onRemove(idx)}
            disabled={disabled}
          >
            Remove
          </MDButton>
        </MDBox>
      </MDBox>

      <Grid container spacing={2} alignItems="flex-start">
        <Grid item xs={12} md={4}>
          <MDSelect
            required
            labelType="non-sticky"
            labelText="Supplier"
            error={!!errors?.supplierId}
            options={supplierOptions}
            value={supplierOptions.find((o) => o.value === line.supplierId) || null}
            onChange={handleSupplierChange}
            isDisabled={disabled}
            placeholder="Select supplier"
          />
          {errors?.supplierId && (
            <MDTypography variant="caption" color="error">
              {errors.supplierId}
            </MDTypography>
          )}
        </Grid>
        <Grid item xs={12} md={4}>
          <MDSelect
            required
            labelType="non-sticky"
            labelText="Payment type"
            options={PAYMENT_TYPE_OPTIONS}
            value={
              PAYMENT_TYPE_OPTIONS.find((o) => o.value === line.paymentType) || null
            }
            onChange={(o) => onUpdate(idx, { paymentType: o?.value })}
            isDisabled={disabled}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <MDNumberInput
            fullWidth
            required
            labelType="non-sticky"
            labelText="Amount"
            value={line.amount}
            onChange={(v) => onUpdate(idx, { amount: v })}
            disabled={disabled}
            error={!!errors?.amount}
          />
          {errors?.amount && (
            <MDTypography variant="caption" color="error">
              {errors.amount}
            </MDTypography>
          )}
        </Grid>

        <Grid item xs={12} md={3}>
          <MDInput
            fullWidth
            labelType="non-sticky"
            labelText="Invoice Serial"
            value={line.invoiceSerial}
            onChange={(e) => onUpdate(idx, { invoiceSerial: e.target.value })}
            disabled={disabled}
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <MDInput
            fullWidth
            labelType="non-sticky"
            labelText="Invoice Number"
            value={line.invoiceNumber}
            onChange={(e) => onUpdate(idx, { invoiceNumber: e.target.value })}
            disabled={disabled}
            error={!!errors?.invoiceNumber}
          />
          {errors?.invoiceNumber && (
            <MDTypography variant="caption" color="error">
              {errors.invoiceNumber}
            </MDTypography>
          )}
        </Grid>
        <Grid item xs={12} md={3}>
          <MDInput
            fullWidth
            type="date"
            labelType="non-sticky"
            labelText="Invoice Date"
            value={line.invoiceDate}
            onChange={(e) => onUpdate(idx, { invoiceDate: e.target.value })}
            disabled={disabled}
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <MDInput
            fullWidth
            labelType="non-sticky"
            labelText="Supplier Tax code"
            value={line.supplierTaxCode}
            onChange={(e) => onUpdate(idx, { supplierTaxCode: e.target.value })}
            disabled={disabled}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <MDInput
            fullWidth
            labelType="non-sticky"
            labelText="Description"
            value={line.description}
            onChange={(e) => onUpdate(idx, { description: e.target.value })}
            disabled={disabled}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <MDInput
            fullWidth
            labelType="non-sticky"
            labelText="Note"
            value={line.note}
            onChange={(e) => onUpdate(idx, { note: e.target.value })}
            disabled={disabled}
          />
        </Grid>

        <Grid item xs={12} md={4}>
          <MDInput
            fullWidth
            type="date"
            labelType="non-sticky"
            labelText="Payment Date"
            value={line.paymentTimeline}
            onChange={(e) => onUpdate(idx, { paymentTimeline: e.target.value })}
            disabled={disabled}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <MDInput
            fullWidth
            labelType="non-sticky"
            labelText="Receiver Name"
            value={line.receiverName}
            onChange={(e) => onUpdate(idx, { receiverName: e.target.value })}
            disabled={disabled}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <MDInput
            fullWidth
            labelType="non-sticky"
            labelText="Bank Account"
            value={line.bankAccount}
            onChange={(e) => onUpdate(idx, { bankAccount: e.target.value })}
            disabled={disabled}
          />
        </Grid>
        <Grid item xs={12}>
          <MDInput
            fullWidth
            labelType="non-sticky"
            labelText="Bank Name / Branch"
            value={line.bankName}
            onChange={(e) => onUpdate(idx, { bankName: e.target.value })}
            disabled={disabled}
          />
        </Grid>
      </Grid>
    </MDBox>
  )
}

export default PaymentLineRow
